<template>
    <div>
        <header class="header-login">
            <div><img src="static/img/logo-ipaas-35x35.png"> <img src="static/img/concrete-datastore.png"></div>
            <div>
                <el-switch
                    :value="localeValue"
                    active-color="#409EFF"
                    inactive-color="#409EFF"
                    active-text="FR"
                    inactive-text="EN"
                    active-value="fr"
                    inactive-value="en"
                    @change="changeLocale"
                >
                </el-switch>
            </div>
        </header>
        <div class="auth-template">
            <h1 class="template-title">{{$t('login.text_before_auth_template.title_before_template')}}</h1>
            <p class="template-introduction">{{$t('login.text_before_auth_template.text_before_template')}}</p>
            <div class="login-template">
                <v-container fluid>
                    <div class="application-title">
                        <h2
                            class="application-second-title"
                        >
                            <div v-if="currentView === 'resetPassword'">
                                <a>
                                    <img
                                        src="static/img/arrow-left.svg"
                                        style="float: left; height: 14px; cursor: pointer;"
                                        @click="currentView = 'login'"
                                    >
                                </a>
                            </div>
                            {{connexionTitle}}
                        </h2>
                        <p v-if="currentView === 'resetPassword'" class="intro-reset-password">
                            {{$t('login.index.reset_password_intro')}}
                        </p>
                    </div>
                    <div v-if="isConfirmPassword">
                        <form-reset-password></form-reset-password>
                    </div>
                    <div v-else-if="currentView==='resetPassword'">
                        <v-form
                            light
                            ref="resetForm"
                            class="form"
                            v-model="resetFormValid"
                            v-on:submit.prevent
                        >
                            <v-text-field
                                light
                                v-model="resetPasswordEmail"
                                :rules="formActive?resetPasswordEmailRules:[]"
                                :label="$t('login.index.label_reset_field')"
                                @input="resetMessages"
                                required
                            ></v-text-field>
                            <div
                                :class="{
                                    content: resetSuccess || resetError,
                                    'reset-success': resetSuccess
                                }"
                                class="message"
                            >
                                <div v-if="resetSuccess" style="background-color: #C8E6C9 !important; border-radius: 4px; padding: 16px; margin-bottom: 24px;">
                                    <img src="static/img/check-circle.svg" style="height: 16px;">
                                    <span style="color: #4CAF50; font-size: 16px; line-height: 21px; font-weight: 400; padding-left: 19px;">{{$t('login.index.reset_success')}}</span>
                                </div>

                                <div
                                    v-else-if="resetError"
                                    class="reset-error"
                                    style="background-color: #FFEBEE !important; border-radius: 4px; padding: 16px; margin-bottom: 24px;">
                                    <img src="static/img/vector.svg" style="height: 16px;">
                                    <span style="color: #F44336; font-size: 16px; line-height: 21px; font-weight: 400; padding-left: 19px;">{{$t('login.index.reset_error')}}</span>
                                </div>
                            </div>
                            <v-btn
                                :disabled="!resetFormValid"
                                :loading="sendingResetRequest"
                                color="light-blue lighten-2"
                                dark
                                @click="validateReset"
                                style="width: 100%; margin: 0;"
                            >
                                {{$t('login.index.reset_btn')}}
                            </v-btn>
                        </v-form>
                    </div>
                    <div v-else-if="currentView==='register'">
                        <v-form
                            light
                            ref="registerForm"
                            class="form"
                            v-model="registerFormValid"
                            v-on:submit.prevent
                        >
                            <v-text-field
                                light
                                v-model="registerEmail"
                                :rules="formActive?emailRules:[]"
                                :label="$t('login.index.label_email_field')"
                                :class="{'v-label--active': email !== ''}"
                                required
                                validate-on-blur
                                @input="resetMessages"
                                @keyup.enter="validateRegister"
                            ></v-text-field>
                            <v-text-field
                                light
                                v-model="registerPassword"
                                :rules="formActive?passwordRules:[]"
                                type="password"
                                :label="$t('login.index.label_password_field')"
                                required
                                @input="resetMessages"
                                @keyup.enter="validateRegister"
                                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                :type="show1 ? 'text' : 'password'"
                                class="input-group--focused"
                                @click:append="show1 = !show1"
                            ></v-text-field>
                            <v-text-field
                                light
                                v-model="registerPasswordConfirm"
                                :rules="formActive?registerPasswordRules:[]"
                                type="password"
                                :label="$t('login.index.password_register_label_confirm')"
                                required
                                @input="resetMessages"
                                @keyup.enter="validateRegister"
                                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                                :type="show2 ? 'text' : 'password'"
                                class="input-group--focused"
                                @click:append="show2 = !show2"
                            ></v-text-field>
                            <v-alert
                                :value="registerError"
                                type="error"
                                class="message"
                                :class="{content: registerError}"
                            >
                                {{registerErrorMessage}}
                            </v-alert>
                            <div class="list-password-register" style="color: #757575;font-size: 16px; text-align: left; margin-bottom: 48px;">
                                <p style="font-weight: 700; margin-bottom: 0;">{{this.$t('login.form_reset_password.list_password')}}</p>
                                <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%; ">
                                    <div class="list-password" style="text-transform: lowercase;">
                                        {{this.$t('login.form_reset_password.list_password_uppercase')}}<br>
                                        {{this.$t('login.form_reset_password.list_password_digit')}}<br>
                                        {{this.$t('login.form_reset_password.list_password_character')}}<br>
                                        {{this.$t('login.form_reset_password.list_password_long_character')}}
                                    </div>
                                </div>

                            </div>

                            <v-btn
                                light
                                :disabled="!isRegisterFormValid"
                                :loading="sendingRegisterRequest"
                                color="light-blue lighten-2"
                                @click="validateRegister"
                                style="width: 100%; margin:0 0 20px 0;"
                            >
                                {{$t('login.form_reset_password.sign_up_register')}}
                            </v-btn>
                            <div>
                                <i18n path="login.form_reset_password.password_descr" class="register-link" style="color: #757575">
                                    <a
                                        @click="currentView = 'login'"
                                        style="padding-top: 24px; text-decoration: underline; color: #2196F3"
                                    >
                                        {{$t('login.form_reset_password.password_link')}}
                                    </a>
                                </i18n>
                            </div>
                        </v-form>
                    </div>
                    <div v-else class="login">
                        <v-form
                            light
                            ref="loginForm"
                            class="form"
                            v-model="loginFormValid"
                            v-on:submit.prevent
                        >
                            <v-text-field
                                light
                                v-model="email"
                                :rules="formActive?emailRules:[]"
                                :placeholder="$t('login.index.label_email_field')"
                                :class="{'v-label--active': email !== ''}"
                                required
                                validate-on-blur
                                @input="resetMessages"
                                @keyup.enter="validate"
                            ></v-text-field>
                            <v-text-field
                                light
                                v-model="password"
                                :rules="formActive?passwordRules:[]"
                                type="password"
                                @input="resetMessages"
                                :placeholder="$t('login.index.label_password_field')"
                                @keyup.enter="validate"
                                required
                                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                :type="show1 ? 'text' : 'password'"
                                class="input-group--focused"
                                @click:append="show1 = !show1"
                            ></v-text-field>


                            <v-alert
                                :value="loginError"
                                type="error"
                                class="message"
                                :class="{content: loginError}"
                            >
                                {{loginErrorMessage}}
                            </v-alert>
                            <a
                                @click="currentView = 'resetPassword'"
                                class="password-forgeot"
                            >{{tabValues[1]}}</a>
                        </v-form>

                        <v-btn
                            light
                            :disabled="!loginFormValid"
                            :loading="sendingLogRequest"
                            color="light-blue "
                            @click="validate"
                            class="button-connexion"
                        >
                            {{$t('login.index.login_btn')}}
                        </v-btn>
                        <div>
                            <i18n path="login.index.register_descr" class="register-link">
                                <a
                                    @click="currentView = 'register'"
                                    style="padding-top: 24px; text-decoration: underline; color: #2196F3"
                                >
                                    {{$t('login.index.register_link')}}
                                </a>
                            </i18n>
                        </div>

                    </div>
                </v-container>
            </div>
        </div>
    </div>


</template>

<script>
import rulesMixins from '@/components/Mixins/rulesMixins.vue';
import FormResetPassword from './form-reset-password.vue';
export default {
    mixins: [rulesMixins],
    components: {FormResetPassword},
    data: function(){
        return {
            show1: false,
            show2: false,
            currentView: 'login',
            loginFormValid: true,
            resetFormValid: true,
            registerFormValid: true,
            regex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            email: '',
            emailRules: [
                v => !!v || this.$t('login.index.email_rule_required'),
                v => {
                    let values = v.match(this.regex);
                    if (values) {
                        return true;
                    }
                    return this.$t('login.index.email_rule_format');
                }
            ],
            password: '',
            passwordRules: [
                v => !!v || this.$t('login.index.password_rule_required')
            ],
            resetPasswordEmail: '',
            resetPasswordEmailRules: [
                v => !!v || this.$t('login.index.email_rule_required'),
                v => {
                    let values = v.match(this.regex);
                    if (values) {
                        return true;
                    }
                    return this.$t('login.index.email_rule_format');
                }
            ],
            tabValues: [
                this.$t('login.index.tab_value_login'),
                this.$t('login.index.tab_value_reset'),
                this.$t('login.index.tab_value_register')
            ],
            registerPasswordRules: [
                v => {
                    if (this.registerPassword === this.registerPasswordConfirm) {
                        return true;
                    }
                    return this.$t('login.index.register_password_rules');
                }
            ],
            activTab: '',
            sendingLogRequest: false,
            sendingResetRequest: false,
            sendingRegisterRequest: false,
            loginError: false,
            loginErrorMessage: '',
            resetSuccess: false,
            resetError: false,
            registerPassword: '',
            registerPasswordConfirm: '',
            registerEmail: '',
            registerError: false,
            registerErrorMessage: '',
        };
    },
    computed: {
        connexionTitle(){
            if(this.currentView === 'login'){
                return this.$t('login.index.login_title');
            }else if(this.currentView === 'register'){
                return this.$t('login.index.login_register_title');
            }else{
                return this.$t('login.index.login_reset_title');
            }

        },
        isConfirmPassword (){
            return window.location.href.includes('reset-password');
        },
        isRegisterFormValid(){
            if(!this.registerEmail) {
                return false;
            }
            if(!this.registerPassword) {
                return false;
            }
            if(!this.registerPasswordConfirm) {
                return false;
            }
            if(this.registerPassword !== this.registerPasswordConfirm) {
                return false;
            }
            return true;
        },
        localeValue() {
            return this.$store.state.currentLocaleValue;
        },
    },
    watch:{
        registerPassword(){
            if(this.registerPasswordConfirm !== ''){
                this.$nextTick(() => {
                    this.$refs.registerForm.validate();
                });
            }
        }
    },
    mounted() {
    },
    methods: {
        changeLocale(value) {
            this.$store.dispatch('changeCurrentLocale', value).then(() => {
                this.$i18n.locale = value;
                this.tabValues = [
                    this.$t('login.index.tab_value_login'),
                    this.$t('login.index.tab_value_reset'),
                    this.$t('login.index.tab_value_register')
                ];
            });
        },
        resetMessages() {
            this.$set(this, 'loginError', false);
            this.$set(this, 'resetSuccess', false);
            this.$set(this, 'resetError', false);
            this.$set(this, 'registerError', false);
        },
        validate () {
            if (this.$refs.loginForm.validate()) {
                this.sendingResetRequest = true;
                this.$store.dispatch('loginUser', {
                    email: this.email,
                    password: this.password,
                }).then(() => {
                    this.sendingResetRequest = false;
                    this.$router.push({name: 'application-list'});
                }).catch((error) => {
                    this.sendingResetRequest = false;
                    this.loginError = true;
                    this.loginErrorMessage = this.$t('login.index.login_error_message');
                });
            }
        },
        validateReset () {
            if (this.$refs.resetForm.validate()) {
                this.sendingResetRequest = true;
                this.$store.dispatch('selfResetUserPassword', {
                    email: this.resetPasswordEmail,
                }).then(() => {
                    this.resetSuccess = true;
                }).catch(() => {
                    this.resetError = true;
                }).finally(() => {
                    this.sendingResetRequest = false;
                });

            }
        },
        validateRegister () {
            if (this.$refs.registerForm.validate()) {
                this.sendingRegisterRequest = true;
                this.$store.dispatch('selfRegisterUser', {
                    email: this.registerEmail,
                    password1: this.registerPassword,
                    password2: this.registerPasswordConfirm,
                }).then(() => {
                    this.sendingRegisterRequest = false;
                    this.registerError = false;
                    this.registerErrorMessage = '';
                    this.$router.push({name: 'application-list'});
                }).catch(() => {
                    this.sendingRegisterRequest = false;
                    this.registerError = true;
                    this.registerErrorMessage = this.$t('login.index.error_register_message');
                });
            }
        },
    },
};
</script>

<style lang="scss">
.header-login{
    display: flex;
    justify-content: space-between;
    margin: 0;
    background-color:#212121;
    padding: 16px 29px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
.auth-template {
    text-align: center;
    color: #ffffff;
    width: 47%;
    max-width: 500px;
    height: auto;
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -50%);
    .template-title{
        font-size: 30px;
        line-height: 35px;
        font-weight: 700;
        margin: 0 0 5px;
    }
    .template-introduction{
        font-size: 16px;
        line-height: 21px;
        font-weight: 400;
        margin-bottom: 40px;
    }
    .login-template{
        border-radius: 4px;
        background-color: white;
        color: black;
        .container{
            padding: 28px 24px;
        }
        .login {
            .loginFormContainer{
                display: flex;
                flex-direction: column-reverse;
            }
            .button-connexion{
                margin-bottom: 24px;
                color: #ffffff;
                background-color: #1565C0;
                width: 100%;
                margin-bottom: 24px;
            }
            .register-link{
                color: #757575;
            }
            .form {

                .message {
                    height: 40px;
                    transition: height .3s cubic-bezier(.25,.8,.5,1);

                }
                .message.content {
                    height: 75px;
                }
                .message.content.reset-success {
                    color: #00C853;
                }

                .v-btn {
                    margin-left: 0;
                    margin-right: 0;
                    width: 100%;
                    &:not(.v-btn--disabled) {
                        color: white;
                    }
                }
                .password-forgeot{
                    display: flex;
                    color: #2196F3;
                    text-decoration: underline;
                    font-size: 16px;
                    line-height: 21px;
                    margin-bottom: 48px;
                }
                .register-link{
                    color: #757575;
                }
                .list-password-register{
                    color: #757575;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    .list-password{
                        display: flex;
                        flex-direction: column;
                    }
                    .list-Value{
                        width: 100%;
                    }
                }
            }
        }
    }
    .container.fluid {
        text-align: center;
    }

    .application-title{
        font-family: 'Open Sans', sans-serif;
        .application-second-title{
            font-weight: bold;
            font-family: Open Sans, sans-serif;
            font-size: 24px;
            line-height: 29px;
        }
        .intro-reset-password{
            margin-top: 24px;
            font-size: 16px;
            line-height: 21px;
            font-weight: 400;
            color: #757575;
            text-align: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Login/index.vue